/**
 * @generated SignedSource<<8dd0ba31a23ea5fd3ef595fdd02c3093>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FileStatus = "ERROR" | "PENDING" | "PROCESSING" | "READY" | "WAIT_FOR_PROCESSING";
import { FragmentRefs } from "relay-runtime";
export type WidgetFilePageProcessing_file$data = {
  readonly status: FileStatus;
  readonly " $fragmentType": "WidgetFilePageProcessing_file";
};
export type WidgetFilePageProcessing_file$key = {
  readonly " $data"?: WidgetFilePageProcessing_file$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetFilePageProcessing_file">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetFilePageProcessing_file",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "File",
  "abstractKey": null
};

(node as any).hash = "d44db6bd808ec98148ed1fad2a6b0ee2";

export default node;
